{
  "eyebrow": "Patvirtinkite planą",
  "title": "Peržiūrėkite ir sukonfigūruokite.",
  "sub": "Atsiskaitymo ciklą ar planą galite pakeisti bet kada administratoriaus skydelyje.",
  "yourPlan": "Jūsų planas",
  "changePlan": "Keisti planą",
  "billing": "Atsiskaitymo ciklas",
  "billingMonthLabel": "Mokėti kas mėnesį",
  "billingMonthDesc": "Lankstu. Atšaukite bet kada.",
  "billingYearLabel": "Mokėti kasmet",
  "billingYearDesc": "~17% nuolaida. Atsiskaitoma kartą per metus.",
  "addons": "Priedai",
  "addon": {
    "ssec": "Socialinis draudimas (check-in/out@work)",
    "ssecDesc": "Tik Belgija — automatinė Dimona deklaracija.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Tiesioginis GPS įmonės transporto priemonėms. +4 €/transporto priemonė/mėn.",
    "vehicles": "Transporto priemonės",
    "projectAddon": "Projektų valdymo priedas",
    "projectAddonDesc": "Atrakina Time Pro projektų valdymo funkcijas (papildomi darbai, planavimas, subrangovų valdymas)."
  },
  "employees": {
    "title": "Kiek darbuotojų?",
    "active": "aktyvūs naudotojai",
    "popular": "Daugumai komandų tinka {{n}}"
  },
  "estimate": "Numatoma mėnesinė kaina",
  "estimateNote": "Be PVM. Mokesčiai už naudotoją skaičiuojami pagal aktyvius darbuotojus.",
  "estimateUnavailable": "Kainoraštis nepasiekiamas. Bandykite dar kartą, kad būtų įkelti naujausi kainos."
}
